import { h, Component } from 'preact';
import style from './style.css';
import common from '../../../../common/common';

export default class NotificationSuccess extends Component {
  render({ closeSuccessMsg, msg }) {
    return (
      <div className={`${style.error}`}>
        <img className={`${style.cross} left`} src={`${common.getStaticPath()}/assets/images/ic-check-cirlce.svg`} />
        <span>{msg}</span>
        <div className={`${style['close-box']}`} onClick={closeSuccessMsg}>
          <img src={`${common.getStaticPath()}/assets/images/ic-clear.svg`} alt="" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/async/notificationsuccess/index.js